import { __awaiter, __generator } from "tslib";
import { SdkMessageTypes } from '../constants';
import { LogLevel, messageToScenarioMap, } from '../interfaces';
export var noPermissionsError = 'App does not have the required permissions for this operation';
/**
 * Base Message handler which checks for SDK initialization before executing message requests.
 */
var BaseMessageHandler = /** @class */ (function () {
    function BaseMessageHandler(appSdkHost, telemetryService) {
        this.appSdkHost = appSdkHost;
        this.telemetryService = telemetryService;
        this.handlers = {};
        this.appDefinition = this.appSdkHost.getAppDefinition();
    }
    BaseMessageHandler.prototype.registerHandler = function (message, callback, options) {
        var _a;
        this.handlers[message] = {
            callback: callback,
            scenarioName: (_a = options === null || options === void 0 ? void 0 : options.scenarioName) !== null && _a !== void 0 ? _a : messageToScenarioMap[message],
            errorCallback: options === null || options === void 0 ? void 0 : options.errorCallback,
            isRestrictedToFullTrustApps: options === null || options === void 0 ? void 0 : options.isRestrictedToFullTrustApps,
            isRestrictedToFullTrustOrLobApps: options === null || options === void 0 ? void 0 : options.isRestrictedToFullTrustOrLobApps,
        };
    };
    BaseMessageHandler.prototype.deleteMessageHandling = function (message) {
        delete this.handlers[message];
    };
    BaseMessageHandler.prototype.canHandleMessage = function (message) {
        return this.validateInitialization(message) && this.handlers[message] !== undefined;
    };
    BaseMessageHandler.prototype.handleMessage = function (message, args, clientTimestamp) {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function () {
            var handler, scenario, result, error_1;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        if (!this.validateInitialization(message)) {
                            return [2 /*return*/, Promise.reject('SDK context is not initialized')];
                        }
                        if (!this.canHandleMessage(message)) {
                            return [2 /*return*/, Promise.reject("Handler cannot handle message: ".concat(message))];
                        }
                        handler = this.handlers[message];
                        if (handler.scenarioName && this.telemetryService) {
                            scenario = this.telemetryService.createScenario(handler.scenarioName, (_a = this.appDefinition) === null || _a === void 0 ? void 0 : _a.id, clientTimestamp);
                            if (clientTimestamp) {
                                scenario.markPhase('MessageDelay');
                            }
                        }
                        _e.label = 1;
                    case 1:
                        _e.trys.push([1, 3, , 4]);
                        // check for full trust only APIs
                        if (handler.isRestrictedToFullTrustApps && !((_b = this.appSdkHost.getAppDefinition()) === null || _b === void 0 ? void 0 : _b.isFullTrust)) {
                            throw noPermissionsError;
                        }
                        // check for full trust or LOB APIs
                        if (handler.isRestrictedToFullTrustOrLobApps &&
                            !(((_c = this.appSdkHost.getAppDefinition()) === null || _c === void 0 ? void 0 : _c.isFullTrust) || !!((_d = this.appSdkHost.getAppDefinition()) === null || _d === void 0 ? void 0 : _d.isLOB))) {
                            throw noPermissionsError;
                        }
                        if (!this.appSdkHost.checkIfCachedAndRequestAllowed(message)) {
                            throw 'Request not allowed when cached';
                        }
                        this.validateDependencies(message);
                        return [4 /*yield*/, handler.callback.apply(this, args)];
                    case 2:
                        result = _e.sent();
                        scenario === null || scenario === void 0 ? void 0 : scenario.stop();
                        return [2 /*return*/, result];
                    case 3:
                        error_1 = _e.sent();
                        this.appSdkHost.getLogger().log(LogLevel.Error, 'handleMessage', 'Error in handling message', error_1);
                        if (handler.errorCallback) {
                            return [2 /*return*/, handler.errorCallback(error_1, scenario)];
                        }
                        else {
                            scenario === null || scenario === void 0 ? void 0 : scenario.fail(error_1);
                            return [2 /*return*/, Promise.reject(error_1)];
                        }
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    BaseMessageHandler.prototype.validateInitialization = function (message) {
        return message === SdkMessageTypes.initialize || this.appSdkHost.isInitialized();
    };
    BaseMessageHandler.prototype.validateDependencies = function (_) { };
    BaseMessageHandler.prototype.cleanup = function () { };
    return BaseMessageHandler;
}());
export { BaseMessageHandler };
//# sourceMappingURL=base-message-handler.js.map